import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteBusBodyWork } from '../../../../actions';

const BusChassisDeleteButton = ({
  dispatchDeleteBusBodywork,
  busBodyWorkId,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () => dispatchDeleteBusBodywork({ busBodyWorkId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

BusChassisDeleteButton.propTypes = {
  dispatchDeleteBusBodywork: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  busBodyWorkId: PropTypes.number.isRequired,
};

BusChassisDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteBusBodywork: deleteBusBodyWork,
};

export default connect(null, mapDispatchToProps)(BusChassisDeleteButton);
